import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";

const ACTION_COLOR = {
  create: "bg-green-100 text-green-800 border-green-200 border",
  update: "bg-blue-100 text-blue-800 border-blue-200 border",
  delete: "bg-red-100 text-red-800 border-red-200 border",
  save: "bg-emerald-100 text-emerald-800 border-emerald-200 border",
  generate: "bg-amber-100 text-amber-800 border-amber-200 border",
};

export default function AuditLog() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    api.get("/audit-logs").then((r) => setLogs(r.data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-5">
      <div>
        <h2 className="font-heading text-2xl font-bold text-slate-900">Audit Log</h2>
        <p className="text-sm text-slate-500 mt-1">Jejak aktivitas perubahan data penting dalam sistem.</p>
      </div>
      <Card className="border-slate-200 shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <Table>
            <TableHeader><TableRow className="bg-slate-50 hover:bg-slate-50">
              <TableHead>Waktu</TableHead><TableHead>Pengguna</TableHead><TableHead>Role</TableHead>
              <TableHead>Aksi</TableHead><TableHead>Entitas</TableHead><TableHead>Keterangan</TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {logs.length === 0 ? (
                <TableRow><TableCell colSpan={6} className="text-center py-10 text-slate-400">Belum ada aktivitas.</TableCell></TableRow>
              ) : logs.map((l) => (
                <TableRow key={l.id} className="hover:bg-slate-50">
                  <TableCell className="text-xs text-slate-500 whitespace-nowrap">{(l.created_at || "").slice(0, 19).replace("T", " ")}</TableCell>
                  <TableCell className="font-medium">{l.user_name}</TableCell>
                  <TableCell className="text-xs text-slate-500">{l.user_role}</TableCell>
                  <TableCell><Badge className={`${ACTION_COLOR[l.action] || "bg-slate-100 border"} capitalize`}>{l.action}</Badge></TableCell>
                  <TableCell className="text-sm">{l.entity}</TableCell>
                  <TableCell className="text-sm text-slate-600">{l.detail}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </Card>
    </div>
  );
}
